import React from "react";
import ReactDOM from "react-dom";
import NumberFormat from "react-number-format";
import numeral from "numeral";

import moment from "moment";

import ResponsiveChart from "components/RunPlot/ResponsiveChart";

import { AutoSizer } from "react-virtualized";

import {
  LineChart,
  Line,
  Scatter,
  CartesianGrid,
  ComposedChart,
  Area,
  CartesianAxis,
  Tooltip,
  Legend,
  XAxis,
  YAxis,
  ZAxis,
  ReferenceLine,
  ReferenceDot,
  ReferenceArea,
  ResponsiveContainer,
  ErrorBar,
  Label,
  Cell,
  LabelList
} from "recharts";

import styles from "./style.module.css";

class MonitoringSummary extends React.PureComponent {
  render() {
    const { monitoringSummary, id } = this.props;

    if (!monitoringSummary?.data?.length) {
      return <React.Fragment />;
    }

    const retData = monitoringSummary.data;
    const label = monitoringSummary.label;

    return (
      // <div className={styles.monitoringSummaryWrapper} id={"monitoringSummary_" + id}>
      <AutoSizer>
        {({ width, height }) => (
          <LineChart
            data={retData}
            margin={{
              top: 10,
              right: 20,
              left: -20,
              bottom: 0
            }}
            width={width}
            height={height}
          >
            <XAxis dataKey="date" tick={false} />
            <YAxis type="number" domain={["auto", "auto"]} tick={false} />
            <Line dataKey={label} dot={false} stroke="#EC6417" strokeWidth={2} />
          </LineChart>
        )}
      </AutoSizer>
      // </div>
    );
  }
}

export default MonitoringSummary;
